module.exports = __webpack_public_path__ + "media/images/tower-79ceeb706f093793f47996f80ec52389.png";